import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ImageGalleryImage, LogoCarouselImage, WebsiteData } from '../state-management/model/interfaces/state.model';
import { FirestoreService } from './firestore.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})

export class WebsiteService {
  private website: WebsiteData | null = null;
  private imageGallery: ImageGalleryImage[] | null = null;
  private logoCarousel: ImageGalleryImage[] | null = null;

  constructor(
    private logger: LoggerService,
    private fireStoreService: FirestoreService
  ) { }

  // Website DATA
  async loadWebsiteData(): Promise<WebsiteData | null> {
    try {
      return this.#loadWebsiteDataBrowser();
    } catch (err) {
      this.logger.error('Fehler beim Laden der Website-Daten:', err);
      return null;
    }
  }


  // Image Gallery DATA
  async loadImageGalleryData(): Promise<ImageGalleryImage[] | null> {
    try {
      return this.#loadImageGalleryDataBrowser();
    } catch (err) {
      this.logger.error('Fehler beim Laden der Website-Daten:', err);
      return null;
    }
  }

  // Logo Carousel DATA
  async loadLogoCarouselData(): Promise<LogoCarouselImage[] | null> {
    try {
      return this.#loadLogoCarouselDataBrowser();
    } catch (err) {
      this.logger.error('Fehler beim Laden der Logo Carousel-Daten:', err);
      return null;
    }
  }

  // Private methods
  async #loadWebsiteDataBrowser(): Promise<WebsiteData | null> {
    try {
      return this.fireStoreService.getWebsiteData();
    } catch (err) {
      this.logger.error('Fehler beim Laden der Website-Daten', err);
      return null;
    }
  }

  async #loadImageGalleryDataBrowser(): Promise<ImageGalleryImage[] | null> {
    try {
      return this.fireStoreService.getImageGallery();
    } catch (err) {
      this.logger.error('Fehler beim Laden der Image Gallery Data', err);
      return null;
    }
  }

  async #loadLogoCarouselDataBrowser(): Promise<LogoCarouselImage[] | null> {
    try {
      return this.fireStoreService.getLogoCarousel();
    } catch (err) {
      this.logger.error('Fehler beim Laden der Logo Carousel Data', err);
      return null;
    }
  }
}